import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

// Base selector for adr data.
const selectADRData = state => state.adrData.data;

// Call automation alert factory selector.
const makeSelectIsCallAutomationAlert = () =>
  createSelector(
    [selectADRData, (_, alertID) => alertID],
    (adrData, alertID) => {
      const selectedAlertADR = adrData?.[`alert://${alertID}`]?.data || null;

      // TODO: This is a short term solution that implements a hidden display schema data to
      // identify whether it is a call automation alert. In the long term, the
      // `is_call_automation_alert` property will be added directly to the alert request payload.
      return Boolean(
        selectedAlertADR?.find(
          adr => adr?.display_schema?.properties?.is_call_automation_alert,
        ),
      );
    },
  );

/**
 * Custom hook selector to identify whether an alert is a call automation alert.
 * @param {String} alertID - Alert ID
 * @returns Boolean
 */
const useIsCallAutomationAlert = (alertID = '') => {
  // Memoize the selector creation to reuse it for the same `selectedAlertID`
  const selectIsCallAutomationAlert = useMemo(
    () => makeSelectIsCallAutomationAlert(),
    [],
  );

  // Use the selector with the `alertID`.
  return useSelector(state =>
    alertID ? selectIsCallAutomationAlert(state, alertID) : false,
  );
};

export default useIsCallAutomationAlert;
